<div class="container-fluid">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/patients'" > Patients </a>
            </li>
            <li
              aria-current="page"
              class="breadcrumb-item active text-gray psp-breadcrumb"
            >
              Patient Profile
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="border-bottom title d-flex p-3 align-items-center mt-2">
      <h2 class="m-0">Procedure Details</h2>
    </div>
    <div class="prescription-files-container">
      <h3 *ngIf="hospitalProcedureFilesAsPDFs?.length">PDFs</h3>
      <div *ngIf="hospitalProcedureFilesAsPDFs?.length" class="files-as-file mb-4">
        <a
          *ngFor="let hospitalProcedureSrc of hospitalProcedureFilesAsPDFs"
          (click)="downloadFile(hospitalProcedureSrc)"
          placement="top"
          tooltip="Click To Download"
        >
          {{ hospitalProcedureSrc.split("/").pop() }}
        </a>
      </div>
      <h3 *ngIf="hospitalProcedureFilesAsImages?.length">Images</h3>
      <div *ngIf="hospitalProcedureFilesAsImages?.length" class="files-as-img">
        <img
          *ngFor="let hospitalProcedureSrc of hospitalProcedureFilesAsImages"
          [src]="hospitalProcedureSrc"
        />
      </div>
    </div>
  </div>
</div>


